import type { ReservationWorkerFragment } from "@stepapp/core";
import { CategoryType } from "@stepapp/core/apiTypes";
import {
  Avatar,
  Block,
  Divider,
  SvgIcon,
  Touchable,
  Typography,
  palette,
  spacing,
} from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

type Props = {
  questionType: string;
  date: string;
  selectedHour: string;
  handleClose: () => void;
  workers?: (ReservationWorkerFragment | null)[];
  categoryType?: CategoryType | null;
};

const Heading = ({
  handleClose,
  questionType,
  date,
  selectedHour,
  workers,
  categoryType = CategoryType.Cleaning,
}: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {questionType === "date" ? (
        <>
          <Block margin={2.5} alignCenter justifySpace row paddingLeft={0.5}>
            <Block alignCenter row>
              <Touchable onPress={handleClose}>
                <Block alignCenter justifyCenter style={styles.closeIcon}>
                  <SvgIcon color={palette.common.gray} name="cross" size={36} />
                </Block>
              </Touchable>

              <Block marginLeft={2.5}>
                <Typography variant="answerTitle">
                  {t("screens.serviceDetails.changeDate2")}
                </Typography>

                <Block row>
                  <Typography type="secondary" variant="lightLabel">
                    {date}
                  </Typography>

                  <Divider spaceless vertical style={styles.dividerStyles} />

                  <Typography type="secondary" variant="lightLabel">
                    {selectedHour}
                  </Typography>
                </Block>
              </Block>
            </Block>

            {!!workers &&
              workers?.map((worker) => (
                <Block alignCenter row key={worker?.id}>
                  <Avatar size={spacing.unit * 3} uri={worker?.avatar} />
                  <Block marginLeft={1.675}>
                    <Typography variant="lightLabelBold">{worker?.name}</Typography>
                  </Block>
                </Block>
              ))}
          </Block>
          <Divider spaceless color={palette.common.mediumGray} />
        </>
      ) : (
        <Block marginTop={2.5} marginHorizontal={2.5}>
          <Block marginBottom={2.5} justifySpace row>
            <Typography variant="newH2">
              {t("screens.serviceDetails.changeServiceDetails", {
                context: categoryType?.toLowerCase(),
              })}
            </Typography>
            <Touchable onPress={handleClose}>
              <Block style={styles.closeIcon}>
                <SvgIcon color={palette.secondary.grey} name="cross" size={38} />
              </Block>
            </Touchable>
          </Block>
          <Divider spaceless />
        </Block>
      )}
    </>
  );
};

export default Heading;

const styles = StyleSheet.create({
  closeIcon: {
    backgroundColor: palette.common.black,
    borderRadius: 20,
  },
  dividerStyles: {
    marginVertical: spacing.unit * 0.5,
  },
});
